const NAME = "ASSETS_DISCOUNTS_ENTRY_BY_API";

export default NAME;
